import {
  TAddFavoriteRequest,
  TAddFavoriteResponse,
  fetchAddFavorite,
} from 'shared/repositories/favorites/v1/add-favorite';
import { IApplicationContext } from '../../types/applicationContext';
import { ResponseError } from 'shared/errors';

export const addToFavorites = async ({ httpApi, logger }: IApplicationContext, parameters: TAddFavoriteRequest) => {
  try {
    const { response, statusCode }: TAddFavoriteResponse = await fetchAddFavorite({
      httpApi,
      parameters,
    });

    if (statusCode !== 200) {
      throw new ResponseError({
        domain: 'addToFavorites',
        message: response.message || '',
        details: {
          errors: JSON.stringify(response.errors),
        },
      });
    }

    return response;
  } catch (e) {
    logger.error(e, {
      domain: 'addToFavorites',
      parameters: JSON.stringify(parameters),
    });

    return null;
  }
};
